interface UserIdentifierLike {
  username?: string | null;
  email?: string | null;
  fullName?: string | null;
  siteId?: number | string | null;
}

const sanitizeSegment = (value?: string | number | null): string | null => {
  if (value === null || value === undefined) return null;
  const str = String(value).trim().toLowerCase();
  if (!str) return null;
  return str.replace(/[^a-z0-9_-]/g, '-');
};

const getSessionUserIdentifier = (): string | null => {
  if (typeof window === 'undefined') return null;
  return (
    sessionStorage.getItem('username') ||
    sessionStorage.getItem('email') ||
    sessionStorage.getItem('user_id') ||
    localStorage.getItem('rememberedUsername')
  );
};

const getSiteFallback = (site?: string | null): string => {
  if (site) {
    const sanitized = sanitizeSegment(site);
    if (sanitized) return sanitized;
  }

  if (typeof window !== 'undefined') {
    const tenant = sessionStorage.getItem('tenant');
    const sanitizedTenant = sanitizeSegment(tenant);
    if (sanitizedTenant) return sanitizedTenant;

    const path = window.location.pathname;
    const match = path.match(/\/entry\/([^\/]+)/);
    if (match && match[1]) {
      const fromPath = sanitizeSegment(match[1]);
      if (fromPath) return fromPath;
    }
  }

  return 'axon';
};

const getUserFallback = (user?: UserIdentifierLike | null): string => {
  const candidates = [
    sanitizeSegment(user?.username),
    sanitizeSegment(user?.email),
    sanitizeSegment(user?.fullName),
    sanitizeSegment(user?.siteId),
    sanitizeSegment(getSessionUserIdentifier())
  ];

  for (const candidate of candidates) {
    if (candidate) return candidate;
  }

  return 'anon';
};

export const buildUserScopedStorageKey = (
  prefix: string,
  site?: string | null,
  user?: UserIdentifierLike | null
): string => {
  const siteSegment = getSiteFallback(site);
  const userSegment = getUserFallback(user);
  return `${prefix}_${siteSegment}_${userSegment}`;
};

export const buildExcelUploadStorageKey = (
  site?: string | null,
  user?: UserIdentifierLike | null
): string => buildUserScopedStorageKey('excelUploadData', site, user);


